import React from 'react';
import {useNavigate} from "react-router-dom"
import './style.css';
  
const SideBar = ({onSelect,selectedPage,user}) => {
  const navigate = useNavigate();
console.log('user?.claims?.role',user?.claims?.role)



  const isSuperAdmin=()=>{
      return (user?.claims?.role==='superAdmin')
    }

    const isAdmin=()=>{
      return (user?.claims?.role==='superAdmin' || user?.claims?.role==='admin')
    }
    
  return (
      <>
      <aside id="sidebar" class="sidebar">

<ul class="sidebar-nav" id="sidebar-nav">

  <li class="nav-item">
    <a class={`nav-link ${selectedPage==='dashboard'?'':'collapsed'}`} href="/home">
      <i class="bi bi-grid"></i>
      <span>Dashboard</span>
    </a>
  </li>


 

  <li class="nav-item">
    <a class={`nav-link ${selectedPage==='orders'?'':'collapsed'}`} data-bs-target="#forms-nav" data-bs-toggle="collapse" href="#" onClick={()=>onSelect('orders')}>
      <i class="bi bi-journal-text"></i><span>Order Details</span>
    </a>

  </li>

  

 

  <li class="nav-item">
    <a class="nav-link collapsed" data-bs-target="#charts-nav" data-bs-toggle="collapse" href="#">
     <a href='#' target='blank' style={{textDecoration:"none", color: '#444444'}}><i class="bi bi-bar-chart"></i><span>Accounts</span></a> 
    </a>

  </li>





</ul>

</aside>
      </>
  )
};
  
export default SideBar;